"use client";

import Link from "next/link";

import { trackEvent } from "@/lib/analytics-events";

/**
 * Front door to the saved daily-panchang surface (ADR-0027). Every generated
 * kundali is persisted under its reading id, and /my-panchang/<id> renders that
 * seeker's chart-personalized daily timing (Choghadiya countdown, rahu-kaal,
 * shubh windows) + the web-push opt-in. A navigation cross-link (rule 39), not
 * an offer — it routes the habit, it does not sell. Same reading id space as
 * /kundali/<id> (vedic_readings), so the link always resolves.
 */
export default function DailyPanchangLink({
  readingId,
  language = "hi",
  source = "kundali_result",
}: {
  readingId: string;
  language?: "en" | "hi";
  source?: string;
}) {
  if (!readingId) return null;
  const hi = language === "hi";
  return (
    <Link
      href={`/my-panchang/${encodeURIComponent(readingId)}/`}
      onClick={() => trackEvent("daily_panchang_entry_clicked", { reading_id: readingId, source })}
      className="mt-4 flex items-center gap-4 rounded-xl p-4 transition-colors"
      style={{ background: "var(--ish-accent-light, #f3e6e0)" }}
    >
      <span aria-hidden className="text-[22px] leading-none">
        {"\u{1FA94}"}
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-body font-semibold" style={{ color: "var(--ish-dark)" }}>
          {hi ? "Aaj ka panchang — sirf aapke liye" : "Your daily panchang"}
        </span>
        <span
          className="block text-caption leading-snug"
          style={{ color: "var(--ish-text-muted)" }}
        >
          {hi
            ? "Aapki kundali ke hisaab se roz ka shubh muhurat, choghadiya aur rahu kaal."
            : "Your chart's auspicious muhurat, choghadiya & rahu kaal — every day."}
        </span>
      </span>
      <span
        className="shrink-0 text-body-small font-semibold"
        style={{ color: "var(--intent-brand-text)" }}
      >
        {hi ? "Dekhein →" : "Open →"}
      </span>
    </Link>
  );
}
